import { getContent } from "../../Core/Content/store";
export interface ServiceOfferingModel {
  id: string;
  title: string;
  summary: string;
  outcomes: string[];
}

export const getServiceOfferingsFn = (): ServiceOfferingModel[] => getContent("services").items as ServiceOfferingModel[];
